<template>
    <div class="AltSymbolsComponent">
        <span >

            <!-- <b-form-input size="sm" v-model="selectedAltSymbols" disabled></b-form-input>   -->
            <b-list-group v-for="item in arrayAltSymbolsToDisplay" :key="item.footprintId" size="sm">
                <b-list-group-item v-if="arrayAltSymbolsToDisplay.length > 0" class="flex-column align-items-start"
                    :variant="variant">
                    <b-row>
                        <b-col cols="2">
                            <div :id="'place_svg_footprint__' + item.footprintId" class="image-footprint"></div>
                        </b-col>
                        <b-col cols="8">
                            <p>{{ item.name }}</p>
                            <b-form-radio-group
                                class="pt-2"
                                :options="['TOP', 'BOTTOM']"
                                :checked="true"
                                v-model="item.side"
                            ></b-form-radio-group>
                        </b-col>
                        <b-col>
                            <b-button class="button" @click="deleteItem(item)" size="sm" :variant="variant">{{ lang.button_Remove }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-list-group-item>

            </b-list-group>
            <br>
            <p>{{ lang.infotext_1 }}:</p><br>
            <AltSymbolsTableComponent :reloadTable="reloadTable" :lang="lang.table_AltSymbols"></AltSymbolsTableComponent>
            <br>
            <span v-if="!appConf.status.isLM">
                <hr>
                <p>{{ lang.infotext_2 }}:</p>
                <b-form inline>

                    <b-form-input id="input-footprint-name" class="input-footprint-name" :state="inputStatus" size="sm"
                        v-model="footprintName" :placeholder="lang.placeholder_Create"
                        aria-describedby="input-footprint-feedback">
                    </b-form-input>

                    <b-form-file v-model="file" :state="Boolean(file)" :placeholder=lang.placeholder_file
                        drop-placeholder="Drop file here..." class="import-file" accept=".svg" size="sm"></b-form-file>

                    <b-button class="btn create-button" size="sm" @click="createFootprint" :variant="variant">
                        {{ lang.button_Create }}</b-button>
                    <b-form-invalid-feedback id="input-footprint-feedback">
                        {{ lang.validinfo_1 }}
                    </b-form-invalid-feedback>



                </b-form>
            </span>
        </span>

        

    </div>
</template>

<script>

import AltSymbolsTableComponent from "@/components/shared/AltSymbolsTableComponent"
import LibraryULComponent from "@/components/shared/LibraryULComponent"
import { mapGetters } from 'vuex'
import LibraryTypes from '@/constants/LibraryTypes'

export default {
    name: 'AltSymbolsComponent',
    components: {
        AltSymbolsTableComponent,
        LibraryULComponent
    },
    props: {
        lang: Object,
        selected: String

    },
    data() {
        return {
            footprintName: "",
            inputStatus: null,
            reloadTable: false,
            file: null,
            isMPN: false,
            mpn: {},
            altSymbolsParams: {},
            part: {},
            tabIndex: 0,
            arrayAltSymbolsToDisplay: []
        }
    },
    computed: {
        ...mapGetters([
            'appConf',

        ]),
        selectedAltSymbols() {
            if (this.$store.getters.selectedAltSymbols.length == 0) {
                this.arrayAltSymbolsToDisplay = [];
                return [];
            }
            this.arrayAltSymbolsToDisplay = this.$store.getters.selectedAltSymbols
            
            return this.$store.getters.selectedAltSymbols;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        textColors() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return ['tabs-bg-dark', 'tabs-text-light']
            } else {
                return ['tabs-bg-light', 'tabs-text-dark']
            }

        },


    },
    created() {
        
        this.getAltSymbolsParams();
        //this.checkIfMPN();

        

    },
    updated() {

        this.getSvg();
    },
    watch: {
        
        selectedAltSymbols: {
            handler: function (newVal) {
                
                this.arrayAltSymbolsToDisplay = newVal;
                
            },
            deep: true
        
            
        },

        reloadTable: function (newVal, oldVal) {

            this.$nextTick(function () {

                if (newVal == true) {
                    this.reloadTable = false;
                }
            })


        },
        tabIndex: function (newVal) {

            
            const objModal = {};

            if (newVal == 0) {
                objModal.ok = false
                objModal.cancel = false

            } else {
                objModal.ok = true
                objModal.cancel = false
            }


            this.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)
        }
    },
    methods: {
        getFootprints() {
            this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteAllSelectedAltSymbols");

            let vue = this;
            
            let selectedArray = this.converseStringSelectedToObj(this.selected);

            if (selectedArray.length > 0) {

                this.$store.dispatch(this.$store.getters.sectionPrefix + '_getFootprints')
                    .then((result) => {
                        console.log(result)
                        if (result.status == "OK") {

                            
                            
                            for (let j = 0, lej = selectedArray.length; j < lej; j++) {
                                for (let i = 0, lei = result.data.length; i < lei; i++) {
                                    
                                    if (result.data[i].name == selectedArray[j].name) {
                                        
                                        const obj = {
                                            name: result.data[i].name,
                                            footprintId: result.data[i].footprintId,
                                            side: selectedArray[j].side
                                        }
                                        
                                        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_addSelectedAltSymbol", obj);
                                        break;
                                    }
                                }

                            }

                        }

                    })
            }
        },
        converseStringSelectedToObj(str) {

             
            const strArray = [];

            if (str.length > 0) {
                
                let firstBracket = str.indexOf("(");

                if (firstBracket > -1 && firstBracket == 0) {
                    
                    let name2 = "";
                    name2 = str.substring(firstBracket + 1, str.length);

                    let secondBracket = name2.indexOf(")");
                    let str2 = "";
                    if (secondBracket > -1) {
                        str2 = name2.substring(0, secondBracket);
                    }

                    

                    if (str2.indexOf(";") > -1) {
                        let temp = str2.split(";");


                        for (let j = 0, lej = temp.length; j < lej; j++) {
                            let obj = {};
                            if (temp[j].indexOf(":") > -1) {
                                let temp2 = temp[j].split(":");

                                if (temp2[0] == "TOP" || temp2[0] == "T") {
                                    obj.side = "TOP";
                                }
                                if (temp2[0] == "BOTTOM" || temp2[0] == "B") {
                                    obj.side = "BOTTOM";
                                }
                                obj.name = temp2[1];

                            } else {
                                obj.side = "undefined";
                                obj.name = temp[1];

                            }
                            strArray.push(obj)
                        }


                    } else {
                        if (str2.indexOf(",") > -1) {
                            let temp = str2.split(",");

                            for (let j = 0, lej = temp.length; j < lej; j++) {
                                let obj = {};
                                if (temp[j].indexOf(":") > -1) {
                                    let temp2 = temp[j].split(":");

                                    if (temp2[0] == "TOP" || temp2[0] == "T") {
                                        obj.side = "TOP";
                                    }
                                    if (temp2[0] == "BOTTOM" || temp2[0] == "B") {
                                        obj.side = "BOTTOM";
                                    }
                                    obj.name = temp2[1];

                                } else {
                                    obj.side = "undefined";
                                    obj.name = temp[j];

                                }
                                strArray.push(obj)
                            }
                        } else {
                            let obj = {};
                            
                            if (str2.indexOf(":") > -1) {
                                let temp2 = str2.split(":");

                                if (temp2[0] == "TOP" || temp2[0] == "T") {
                                    obj.side = "TOP";
                                }
                                if (temp2[0] == "BOTTOM" || temp2[0] == "B") {
                                    obj.side = "BOTTOM";
                                }
                                obj.name = temp2[1];

                            } else {
                                
                                obj.side = "undefined";
                                obj.name = str2;

                            }
                            strArray.push(obj)
                        }
                    }

                    

                } else {
                   
                    if (str.indexOf(";") > -1) {
                        let temp = str.split(";");
                        
                        
                        for (let j = 0, lej = temp.length; j < lej; j++) {
                            let obj = {};
                            if (temp[j].indexOf(":") > -1) {
                                let temp2 = temp[j].split(":");
                                
                                if (temp2[0] == "TOP" || temp2[0] == "T") {
                                    obj.side = "TOP";
                                }
                                if (temp2[0] == "BOTTOM" || temp2[0] == "B") {
                                    obj.side = "BOTTOM";
                                }
                                obj.name = temp2[1];
                                
                            } else {
                                obj.side = "undefined";
                                obj.name = temp[1];
                                
                            }
                            strArray.push(obj)
                        }

                        
                    } else {
                        if (str.indexOf(",") > -1) {
                            let temp = str.split(",");

                            for (let j = 0, lej = temp.length; j < lej; j++) {
                                let obj = {};
                                if (temp[j].indexOf(":") > -1) {
                                    let temp2 = temp[j].split(":");
                                    
                                    if (temp2[0] == "TOP" || temp2[0] == "T") {
                                        obj.side = "TOP";
                                    }
                                    if (temp2[0] == "BOTTOM" || temp2[0] == "B") {
                                        obj.side = "BOTTOM";
                                    }
                                    obj.name = temp2[1];

                                } else {
                                    obj.side = "undefined";
                                    obj.name = temp[j];

                                }
                                strArray.push(obj)
                            }
                        } else {
                            let obj = {};
                            if (str.indexOf(":") > -1) {
                                let temp2 = str.split(":");
                                
                                if (temp2[0] == "TOP" || temp2[0] == "T") {
                                    obj.side = "TOP";
                                }
                                if (temp2[0] == "BOTTOM" || temp2[0] == "B") {
                                    obj.side = "BOTTOM";
                                }
                                obj.name = temp2[1];

                            } else {
                                obj.side = "undefined";
                                obj.name = str;

                            }
                            strArray.push(obj)
                        }
                    }
                



                }
            }
            
            
            
            return strArray;

            
        },
        switchTabIndex(index) {

            this.tabIndex = index

        },
        getAltSymbolsParams() {
            
            let vue = this;

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getAltSymbolsParams")
                .then((result) => {
                    console.log(result)
                    
                    vue.altSymbolsParams = result.data[0];
                    vue.getFootprints();
                })

        },
        checkIfMPN() {

            let vue = this;

            if (this.$store.getters.selectedRows.length > 0) {
                const obj = {
                    partId: this.$store.getters.selectedRows[0].col___revisionId.partId
                }
                this.$store.dispatch(this.$store.getters.sectionPrefix + '_getPhysicals', obj)
                    .then((result) => {
                        console.log(result)
                        if (result.status == "OK") {
                            if (result.data.length > 0) {
                                vue.isMPN = true;
                                vue.mpn.ManufacturerName = result.data[0].ManufacturerName
                                vue.mpn.ManufacturerPartNumber = result.data[0].ManufacturerPartNumber

                                let obj = {
                                    manufacturerName: vue.mpn.ManufacturerName,
                                    manufacturerPartNumber: vue.mpn.ManufacturerPartNumber
                                }

                                this.$store.dispatch(this.$store.getters.sectionPrefix + '_findPart', obj)
                                    .then((result) => {
                                        console.log(result)
                                        if (result.status == "OK") {

                                            if (result.data != null) {
                                                vue.part = result.data;



                                            } else {

                                            }

                                        }
                                    })

                            }

                        }
                    })
            }



        },
        deleteItem(item) {

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedAltSymbol", item);

        },
        createFootprint() {

            if (this.footprintName != "") {
                let obj = {
                    name: this.footprintName,

                }
                let vue = this;
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_createFootprint", obj)
                    .then((result) => {

                        if (result.status == "OK") {

                            if (vue.file != null) {
                                const objFile = {
                                    type: LibraryTypes.FOOTPRINT,
                                    file: vue.file
                                }

                                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_uploadSvg", objFile)
                                    .then((result) => {
                                        console.log(result.data)



                                    })
                            }

                            const obj = {
                                text: this.lang.alert_success_create_footprint,
                                time: 5,
                                type: "success"
                            }

                            this.$store.dispatch("displayFooterAlert", obj);

                            vue.footprintName = "";
                            vue.inputStatus = null;
                            vue.reloadTable = true;

                            let input = document.getElementById("input-footprint-name");

                            input.setAttribute("class", "input-footprint-name");

                            //todo reload table with footprints
                        } else {
                            const obj = {
                                text: this.lang.alert_error_create_footprint,
                                time: 10,
                                type: "danger"
                            }

                            this.$store.dispatch("displayFooterAlert", obj);
                        }
                    })


            } else {
                this.inputStatus = false;
            }



        },
        getSvg() {

            let vue = this;

            if (this.selectedAltSymbols[0] == undefined) {
                return
            }
            if (this.selectedAltSymbols[0].name == "") {
                return
            }
            for (let i = 0, lei = this.selectedAltSymbols.length; i < lei; i++) {
                const obj = {
                    type: LibraryTypes.FOOTPRINT,
                    name: this.selectedAltSymbols[i].name,
                    id: "place_svg_footprint__" + this.selectedAltSymbols[i].footprintId
                }
                this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSvg", obj)
                    .then((result) => {

                        if (result != null) {


                            let id = result.id;
                            vue.loadSVG(result, id);


                        }

                    })
            }


        },
        async loadSVG(result, id) {

            

            let place = document.getElementById(id);

            if (place != null) {

                if (result.noImage == false) {
                    place.innerHTML = "";
                    let svgData = await new Response(result).text();
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(svgData, "image/svg+xml");
                    doc.documentElement.setAttribute("width", 100);
                    doc.documentElement.setAttribute("height", 100);

                    place.appendChild(doc.documentElement);

                } else {
                    place.innerHTML = "<p class=\"noimage\">No image</p>";
                }

            }

        },
    }


}
</script>


<style lang="scss">
//@import "./../../scss/_modal.scss";


    .list-group-item {
        padding: 0.25rem 0.25rem;


    }

    .create-button {
        margin-left: 10px;
    }

    .import-file {
        width: 400px !important;
        margin-left: 10px;


    }

    .input-footprint-name {
        width: 200px !important;
    }

    .image-footprint {
        background-color: #ffffff;
        border: 1px solid #dee2e6;
        border-radius: 0.25rem;
        margin: 5px;
        overflow: hidden;
        width: 100px;
        height: 100px;
        display: block;

    }
    .noimage{
        color: #333;
        margin: 20px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/AltSymbolsComponent.vue